import { render, staticRenderFns } from "./form-signup.vue?vue&type=template&id=2ecdcdaf&"
import script from "./form-signup.vue?vue&type=script&lang=js&"
export * from "./form-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports